import styled from "styled-components";

const BoardContainer = styled.div`
  table {
    text-align: center;
    border-collapse: collapse;
    width: 100%;
    border-top: 2px solid rgb(33, 175, 196);
    border-bottom: 2px solid rgb(33, 175, 196);
    th {
      background-color: rgb(247, 247, 247);
      text-align: center;
      padding: 1% 0;
      font-size: 0.8rem;
      color: #666;
    }
    tbody {
      tr {
        border-top: 1px solid #e7e7e7;
        border-bottom: 1px solid #e7e7e7;
        border-collapse: collapse;
      }
      td {
        padding: 1.3% 0;
        font-size: 0.8rem;
        color: #666;
      }
      .boardtitle {
        text-align: left;
        a {
          color: black;
          text-decoration: none;
          cursor: pointer;
        }
        img {
          vertical-align: bottom;
          width: 20px;
        }
      }
    }
  }
  a {
    color: black;
    text-decoration: none;
  }
  .BoardWriteBtn {
    text-align: right;
    padding-bottom: 1em;
    a {
      cursor: pointer;
      background-color: rgb(33, 175, 196);
      color: white;
      font-size: 0.8rem;
      border: 1px solid rgb(33, 175, 196);
      border-radius: 5px;
      box-shadow: 2px 3px 8px 1px rgb(33, 175, 196);
      padding: 0.5em 1.5em;
      &:hover {
        color: #000;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    table {
      tbody {
        .boardtitle {
          text-align: center;
          a {
            text-align: center;
          }
          img {
            width: 10%;
          }
        }
      }
    }
    .BoardWrite {
      float: none;
      text-align: right;
      margin-right: 1em;
    }
  }
`;

const BoardDetailContainer = styled.div`
  .BoardDetailPassword {
    width: 100%;
    margin-top: 1em;
    & > img {
      width: 100%;
    }
  }

  .BoardDetailPasswordInputContainer {
    background-color: rgb(243, 243, 243);
    padding: 1em 0;
    input {
      width: 30%;
      padding: 0.4em;
      border-color: transparent;
    }
    button {
      width: 10%;
      background-color: rgb(22, 171, 193);
      color: white;
      border: 1px solid rgb(22, 171, 193);
      padding: 0.5em 0;
      margin: 2em 0.5em;
      box-shadow: 0 2px 8px #999 inset, 0 -2px 8px #666 inset;
      min-height: 1em;
      cursor: pointer;
    }
    .BoardDetailCancel {
      background-color: rgb(146, 146, 146);
      border: 1px solid rgb(146, 146, 146);
    }
  }
  .BoardDetailPasswordInputContainerTitle {
    display: flex;
    justify-content: center;
    gap: 0 0.5em;
    margin-bottom: 1em;
    p {
      font-size: 1rem;
      margin: 0;
    }
    img {
      margin-top: 0.3em;
      height: 100%;
    }
  }
  .BoardDetail {
    border-collapse: collapse;
    width: 100%;
    border-top: 2px solid rgb(33, 175, 196);
    border-bottom: 2px solid rgb(33, 175, 196);
  }
  .BoardDetailRow {
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    border-collapse: collapse;
    display: flex;
    font-size: 0.8rem;
    color: #666;
  }
  .BoardDetailTitle {
    width: 12%;
    background-color: rgb(247, 247, 247);
    text-align: center;
    padding: 1% 0;
    font-size: 1rem;
    word-break: break-all;
    line-height: 2em;
  }
  .BoardDetailContent {
    font-size: 1rem;
    word-break: break-all;
    text-align: left;
    line-height: 3em;
    margin-left: 1em;
    a {
      color: #666;
      text-decoration: none;
    }
  }
  .BoardDetailDescription {
    width: 100%;
    p {
      font-size: 1rem;
      text-align: left;
      padding: 1.5em 1em;
      margin: 0;
    }
  }
  button {
    width: 10%;
    background-color: rgb(22, 171, 193);
    color: white;
    border: 1px solid rgb(22, 171, 193);
    padding: 0.5em 0;
    margin: 2em auto;
    box-shadow: 0 2px 8px #999 inset, 0 -2px 8px #666 inset;
    min-height: 1em;
    cursor: pointer;
  }
  @media only screen and (max-width: 480px) {
    .BoardDetailTitle {
      width: 20%;
      font-size: 0.8rem;
    }
    .BoardDetailContent {
      font-size: 12px;
      width: 70%;
    }
    button {
      width: 25%;
      padding: 1em 0;
      font-size: 0.9rem;
    }
  }
`;

const BoardWriteContainer = styled.div`
  .BoardWrite {
    border-collapse: collapse;
    width: 100%;
    border-top: 2px solid rgb(33, 175, 196);
    border-bottom: 2px solid rgb(33, 175, 196);
  }
  .BoardWriteRow {
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    border-collapse: collapse;
    display: flex;
    font-size: 0.8rem;
    color: #666;
  }
  .BoardWriteTitle {
    width: 15%;
    background-color: rgb(247, 247, 247);
    text-align: center;
    padding: 1% 0;
    line-height: 2em;
  }
  .BoardWriteContent {
    width: 100%;
    line-height: 3em;
    text-align: left;
    padding-left: 1em;
    input {
      text-align: left;
      font-size: 1rem;
      padding: 0 0.5em;
      height: 3.5vh;
    }
    span {
      color: #929292;
      font-size: 0.8rem;
    }
  }
  .BoardWriteInputTitle {
    margin: auto 0;
    height: 60%;
    width: 90%;
  }
  .BoardWritePassword {
    display: flex;
    div {
      margin-left: 1em;
    }
  }
  .BoardDetailDescription {
    width: 100%;
  }
  .BoardWriteCancel {
    background-color: rgb(146, 146, 146);
    border: 1px solid rgb(146, 146, 146);
  }
  textarea {
    width: 95%;
    margin: 1em auto;
    resize: none;
    text-align: left;
    height: 20vh;
  }
  button {
    width: 10%;
    background-color: rgb(22, 171, 193);
    color: white;
    border: 1px solid rgb(22, 171, 193);
    padding: 0.5em 0;
    margin: 2em 0.5em;
    box-shadow: 0 2px 8px #999 inset, 0 -2px 8px #666 inset;
    min-height: 1em;
    cursor: pointer;
  }
  input,
  textarea {
    border: 1px solid #e7e7e7;
  }
  @media only screen and (max-width: 480px) {
    .BoardWriteTitle {
      width: 25%;
    }
    .BoardWritePassword {
      div {
        word-break: keep-all;
        text-align: left;
        margin: 0;
      }
      display: block;
    }
    button {
      width: 25%;
      padding: 1em 0;
      font-size: 0.9rem;
    }
  }
`;

const PaginationContainer = styled.div`
  margin-top: 1.8em;
  font-size: 0.8rem;
  ul {
    width: 30%;
    margin: 0 auto;
    display: flex;
    list-style-type: none;
    padding: 0;
    li {
      margin: 0 auto;
      padding: 0;
    }
  }
  .ActivePage {
    text-decoration: none;
    color: rgb(33, 175, 196);
  }
  .Button {
    padding: 0;
    margin: 0 2%;
    a {
      color: rgb(33, 175, 196);
    }
  }
  @media only screen and (max-width: 480px) {
    margin: 1em;
    font-size: 1.2rem;
    ul {
      width: 100%;
    }
  }
`;

const BoardCss = {
  BoardContainer,
  BoardDetailContainer,
  PaginationContainer,
  BoardWriteContainer
};

export default BoardCss;
